import React, { useEffect, Fragment, useState } from "react"
import { Container, Table } from "react-bootstrap"
import NavBarUser from "../../components/shared/NavBarUser"
import { withRouter, Link } from "react-router-dom"
import { getUsersAdmin } from "../../services/admin.service.js"
import Loader from "../../components/shared/Loader"
import { formatDate } from "../../utils"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

const AdminUsuarios = () => {
	const [users, setUsers] = useState([])
	const [loader, setLoader] = useState()

	useEffect(() => {
		const getusers = async () => {
			setLoader(true)
			const res = await getUsersAdmin()
			console.log(res)
			setUsers(res.data)
			setLoader(false)
		}
		if (users) {
			getusers()
		}
	}, [])

	return (
		<Fragment>
			<NavBarUser />
			<Container className="mt-4">
				<h1>Usuarios</h1>
				{loader ? (
					<Loader />
				) : (
					<Table bordered responsive>
						<thead>
							<tr>
								<th>N°</th>
								<th>ID</th>
								<th>RUN</th>
								<th>Nombre Completo</th>
								<th colSpan="2">Acciones</th>
							</tr>
						</thead>
						<tbody>
							{users.map((user, index) => {
								return (
									<tr key={index}>
										<td>{index + 1}</td>
										<td>{user.id}</td>
										<td>{user.run}</td>
										<td>{user.nombres + " " + user.paterno + " " + user.materno}</td>
										<td class="text-center">
											<span
												className="text-primary a-link"
												onClick={() => console.log("Edita unidad")}
											>
												<FontAwesomeIcon icon="edit" size="2x" />
											</span>
										</td>
										<td class="text-center">
											<span
												className="text-danger a-link"
												onClick={() => console.log("delete unidad")}
											>
												<FontAwesomeIcon icon="trash" size="2x" />
											</span>
										</td>
									</tr>
								)
							})}
						</tbody>
					</Table>
				)}
				<hr />
				<Link className="btn btn-success">
					<FontAwesomeIcon icon="plus" className="mr-2" />
					Nuevo Usuario
				</Link>
			</Container>
		</Fragment>
	)
}

export default withRouter(AdminUsuarios)
